import "../scss/styles.scss";
let Swiper, Navigation, Pagination, Autoplay;

const LANGUAGE_URL_MAP = {
  pl: "pl",
  en: "en",
};

const META_DESCRIPTIONS = {
  pl: "Polybility — bezpieczne kontrakty na usługi IT: generowanie umów przez AI, podpis kwalifikowany (eIDAS) i escrow w jednym procesie. Testuj za darmo do lutego 2027.",
  en: "Polybility — secure contracts for IT services: AI contract generation, qualified e-signature (eIDAS) and escrow in one process. Free testing until February 2027.",
};

const META_TITLES = {
  pl: "Bezpieczne kontrakty na usługi IT | Polybility",
  en: "Secure Contracts for IT Services | Polybility",
};

const OG_DESCRIPTIONS = {
  pl: "Polybility — bezpieczne kontrakty na usługi IT: generowanie umów przez AI, podpis kwalifikowany (eIDAS) i escrow w jednym procesie. Testuj za darmo do lutego 2027.",
  en: "Polybility — secure contracts for IT services: AI contract generation, qualified e-signature (eIDAS) and escrow in one process. Free testing until February 2027.",
};

const TWITTER_DESCRIPTIONS = {
  pl: "Polybility — bezpieczne kontrakty na usługi IT.",
  en: "Polybility — secure contracts for IT services.",
};

function runOnFirstInteraction(callback) {
  let executed = false;
  const run = () => {
    if (executed) return;
    executed = true;
    cleanup();
    callback();
  };
  const cleanup = () => {
    window.removeEventListener("scroll", run, listenerOpts);
    window.removeEventListener("pointerdown", run, listenerOpts);
    window.removeEventListener("keydown", run, listenerOpts);
    window.removeEventListener("touchstart", run, listenerOpts);
  };
  const listenerOpts = { passive: true, once: true };
  window.addEventListener("scroll", run, listenerOpts);
  window.addEventListener("pointerdown", run, listenerOpts);
  window.addEventListener("keydown", run, listenerOpts);
  window.addEventListener("touchstart", run, listenerOpts);
}

function normalizeAssetUrls() {
  const absolutize = (value) => {
    if (!value || value.startsWith("/") || value.startsWith("http://") || value.startsWith("https://") || value.startsWith("data:") || value.startsWith("#")) {
      return value;
    }
    if (value.startsWith("assets/")) {
      return `/${value}`;
    }
    return value;
  };

  document.querySelectorAll("img[src]").forEach((el) => {
    const src = el.getAttribute("src");
    const next = absolutize(src);
    if (next !== src) el.setAttribute("src", next);
  });

  document.querySelectorAll("source[srcset]").forEach((el) => {
    const srcset = el.getAttribute("srcset");
    const next = absolutize(srcset);
    if (next !== srcset) el.setAttribute("srcset", next);
  });

  document.querySelectorAll("link[href]").forEach((el) => {
    const href = el.getAttribute("href");
    const next = absolutize(href);
    if (next !== href) el.setAttribute("href", next);
  });
}

// Lazy load Swiper modules to reduce initial bundle size
async function loadSwiperModules() {
  if (!Swiper) {
    Swiper = (await import("swiper")).default;
    await import("swiper/css");
    await import("swiper/css/navigation");
    await import("swiper/css/pagination");
    const modules = await import("swiper/modules");
    Navigation = modules.Navigation;
    Pagination = modules.Pagination;
    Autoplay = modules.Autoplay;
  }
  return { Swiper, Navigation, Pagination, Autoplay };
}


//  navbar
const toggleActiveClasses = (element, isActive) => {
  const link = element.querySelector(".nav-link");
  const icon = element.querySelector(".navbar__icon");

  if (!link || !icon) return;

  element.classList.toggle("active", isActive);
  link.classList.toggle("active", isActive);
  icon.classList.toggle("active", isActive);
};

// sidebar
const toggleSidebarActiveClasses = (element, isActive) => {
  const link = element.querySelector(".sidebar__nav-link");
  const icon = element.querySelector(".sidebar__icon");

  if (!link) return;

  element.classList.toggle("active", isActive);
  link.classList.toggle("active", isActive);
  if (icon) icon.classList.toggle("active", isActive);
};

// Language switcher for sidebar
const setupLanguageSwitcher = () => {
  const languageSwitcher = document.getElementById("languageSwitcher");
  if (!languageSwitcher) return;

  const languages = {
    pl: { flag: "🇵🇱", full: "🇵🇱 Polski" },
    en: { flag: "🇬🇧", full: "🇬🇧 English" },
  };

  // Store original texts and add data attributes
  languageSwitcher.querySelectorAll("option").forEach(option => {
    const lang = languages[option.value];
    if (lang) {
      if (!option.hasAttribute("data-original")) {
        option.setAttribute("data-original", option.textContent);
      }
      option.setAttribute("data-flag", lang.flag);
      option.setAttribute("data-full", lang.full);
    }
  });

  const updateDisplay = () => {
    const selectedOption = languageSwitcher.querySelector(`option[value="${languageSwitcher.value}"]`);

    if (selectedOption) {
      const text = selectedOption.getAttribute("data-original") || selectedOption.getAttribute("data-full");
      if (text) selectedOption.textContent = text;
    }
  };

  const restoreAllOptions = () => {
    languageSwitcher.querySelectorAll("option").forEach(option => {
      const full = option.getAttribute("data-original") || option.getAttribute("data-full");
      if (full) option.textContent = full;
    });
  };

  // Event listeners
  languageSwitcher.addEventListener("focus", restoreAllOptions);
  languageSwitcher.addEventListener("blur", updateDisplay);
  languageSwitcher.addEventListener("change", updateDisplay);

  // Initial update
  updateDisplay();
};

// Sidebar initialization - defer to reduce TBT
document.addEventListener("DOMContentLoaded", () => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      setupLanguageSwitcher();
    }, { timeout: 500 });
  } else {
    setTimeout(() => {
      setupLanguageSwitcher();
    }, 50);
  }
});

// Navigation scroll spy - defer to reduce TBT
let navigationScrollSpyInitialized = false;
function initNavigationScrollSpy() {
  if (navigationScrollSpyInitialized) return;
  navigationScrollSpyInitialized = true;
  const navItems = document.querySelectorAll(".nav-item");
  const sidebarNavItems = document.querySelectorAll(".sidebar__nav-item");
  const sections = document.querySelectorAll("section");
  const links = document.querySelectorAll(".nav-link");
  const sidebarLinks = document.querySelectorAll(".sidebar__nav-link");
  const navbarCollapse = document.getElementById("navbarNav");
  const navbarIcon = document.getElementById("navbarIcon");
  let currentSectionId = null;

  // Cache link targets once to avoid repeated querySelector/getAttribute calls.
  const navTargets = Array.from(navItems).map((navItem) => {
    const link = navItem.querySelector(".nav-link");
    return {
      navItem,
      href: link?.getAttribute("href") || null
    };
  });
  const sidebarTargets = Array.from(sidebarNavItems).map((sidebarItem) => {
    const link = sidebarItem.querySelector(".sidebar__nav-link");
    return {
      sidebarItem,
      href: link?.getAttribute("href") || null
    };
  });

  /* 
   * IntersectionObserver approach for robust "scroll spy" behavior.
   * We use a rootMargin that effectively shrinks the viewport to a thin line 
   * (or small area) around the middle/top-third of the screen.
   * Whichever section intersects this line is considered "active".
   */
  const observerOptions = {
    root: null,
    // -30% from top, -50% from bottom. 
    // This detects sections entering the "upper middle" part of the screen.
    rootMargin: "-30% 0px -50% 0px",
    threshold: 0
  };

  // Throttle observer callbacks to reduce forced reflows
  let observerTicking = false;
  const observer = new IntersectionObserver((entries) => {
    if (!observerTicking) {
      requestAnimationFrame(() => {
        let nextSectionId = null;
        entries.forEach((entry) => {
          // We only care if the element is intersecting our specific "active zone"
          if (entry.isIntersecting && !nextSectionId) {
            nextSectionId = entry.target.getAttribute("id");
          }
        });

        if (nextSectionId && nextSectionId !== currentSectionId) {
          const activeHash = `#${nextSectionId}`;

          // Update Navbar (Desktop/Mobile) only when active section changes.
          navTargets.forEach(({ navItem, href }) => {
            toggleActiveClasses(navItem, href === activeHash);
          });

          // Update Sidebar only when active section changes.
          sidebarTargets.forEach(({ sidebarItem, href }) => {
            toggleSidebarActiveClasses(sidebarItem, href === activeHash);
          });

          currentSectionId = nextSectionId;
        }
        observerTicking = false;
      });
      observerTicking = true;
    }
  }, observerOptions);

  // Observe all sections
  sections.forEach((section) => observer.observe(section));

  // Toggle Menu Logic
  const toggleMenu = () => {
    if (!navbarCollapse || !navbarIcon) return;
    const isMenuOpen = navbarCollapse.classList.toggle("show");
    navbarIcon.textContent = isMenuOpen ? "close" : "menu";
  };

  // Smooth Scroll for Navbar Links
  links.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = link.getAttribute("href");
      const targetSection = document.querySelector(targetId);
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: "smooth", block: "start" });
        if (navbarCollapse?.classList.contains("show")) {
          navbarCollapse.classList.remove("show");
          navbarIcon.textContent = "menu";
        }
      }
    });
  });

  // Smooth Scroll for Sidebar Links
  sidebarLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const targetId = link.getAttribute("href");
      const targetSection = document.querySelector(targetId);
      if (targetSection) {
        targetSection.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });
  });

  window.toggleMenu = toggleMenu;
}

// Initialize navigation scroll-spy only after first interaction or load fallback
document.addEventListener("DOMContentLoaded", () => {
  runOnFirstInteraction(initNavigationScrollSpy);
  window.addEventListener("load", () => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(initNavigationScrollSpy, { timeout: 2500 });
    } else {
      setTimeout(initNavigationScrollSpy, 600);
    }
  }, { once: true });
});

// Sticky Banner - defer to reduce TBT
function initStickyBanner() {
  const stickyBanner = document.querySelector(".sticky-banner");

  if (!stickyBanner) return;

  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.has("reset-banner")) {
    localStorage.removeItem("stickyBannerClosed");
  }

  const bannerClosed = localStorage.getItem("stickyBannerClosed");
  if (!bannerClosed) {
    stickyBanner.classList.add("show");
  }
}

// Defer sticky banner initialization
document.addEventListener("DOMContentLoaded", () => {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initStickyBanner, { timeout: 3000 });
  } else {
    setTimeout(initStickyBanner, 600);
  }
});

window.closeStickyBanner = function () {
  const stickyBanner = document.querySelector(".sticky-banner");
  if (!stickyBanner) return;

  stickyBanner.classList.remove("show");
  localStorage.setItem("stickyBannerClosed", "true");
};




// FAQ accordion exclusive open behavior
document.addEventListener("DOMContentLoaded", () => {
  const faqList = document.querySelector(".faq__list");
  if (!faqList) return;

  const detailsElements = faqList.querySelectorAll("details.faq__item");
  detailsElements.forEach((targetDetail) => {
    targetDetail.addEventListener("toggle", (e) => {
      if (targetDetail.open) {
        detailsElements.forEach((detail) => {
          if (detail !== targetDetail && detail.open) {
            detail.removeAttribute("open");
          }
        });
      }
    });
  });
});

// Language switcher - direct static routing redirect
function initLanguageSwitchers() {
  const languageSwitcher = document.getElementById("languageSwitcher");
  const languageSwitcherMobile = document.getElementById("languageSwitcherMobile");

  const pageLang = document.documentElement.lang || "pl";

  const syncLanguageSwitchers = (value) => {
    if (languageSwitcher) languageSwitcher.value = value;
    if (languageSwitcherMobile) languageSwitcherMobile.value = value;
  };

  // Sync both selects on load to current HTML lang attribute
  syncLanguageSwitchers(pageLang);

  const onLanguageChange = (event) => {
    const selectedLang = event.target.value;
    if (selectedLang !== pageLang) {
      const langSegment = LANGUAGE_URL_MAP[selectedLang] || "pl";
      window.location.href = `/${langSegment}/`;
    }
  };

  if (languageSwitcher) {
    languageSwitcher.addEventListener("change", onLanguageChange);
  }
  if (languageSwitcherMobile) {
    languageSwitcherMobile.addEventListener("change", onLanguageChange);
  }
}

// Initialize language switchers after critical content loads
document.addEventListener("DOMContentLoaded", () => {
  normalizeAssetUrls();
  if ('requestIdleCallback' in window) {
    requestIdleCallback(initLanguageSwitchers, { timeout: 500 });
  } else {
    setTimeout(initLanguageSwitchers, 50);
  }
});

// Swiper - Lazy load to reduce TBT

function initSwipers() {
  // App Screenshots Swiper - lazy load when visible
  const appScreenshotsSwiper = document.querySelector(".app-screenshots__swiper");
  if (appScreenshotsSwiper) {
    const swiperObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          swiperObserver.unobserve(entry.target);
          
          // Use requestIdleCallback for non-critical initialization
          const initSwiper = () => {
            loadSwiperModules().then(({ Swiper: SwiperModule, Navigation: NavModule, Pagination: PagModule, Autoplay: AutoplayModule }) => {
              new SwiperModule(appScreenshotsSwiper, {
                modules: [NavModule, PagModule, AutoplayModule],
              loop: true,
              spaceBetween: 30,
              autoplay: { delay: 4000, pauseOnMouseEnter: true },
              pagination: { el: ".app-screenshots__pagination", clickable: true, dynamicBullets: true },
              navigation: {
                nextEl: ".app-screenshots__button-next",
                prevEl: ".app-screenshots__button-prev",
                addIcons: false,
              },
              // Optimize for performance - reduce forced reflows
              watchOverflow: true,
              observer: true,
              observeParents: true,
              // Use CSS transforms instead of layout properties
              speed: 600,
              resistance: true,
              resistanceRatio: 0.85,
              // Prevent layout thrashing
              preventClicks: false,
              preventClicksPropagation: false,
              breakpoints: {
                320: { spaceBetween: 15 },
                640: { spaceBetween: 20 },
                768: { spaceBetween: 25 },
                1024: { spaceBetween: 30 },
              },
              });
            });
          };
          
          if ('requestIdleCallback' in window) {
            requestIdleCallback(initSwiper, { timeout: 2000 });
          } else {
            setTimeout(initSwiper, 100);
          }
        }
      });
    }, { rootMargin: '50px' });
    
    swiperObserver.observe(appScreenshotsSwiper);
  }

}

// Initialize Swipers after DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  initSwipers();
});

document.addEventListener("click", (e) => {
  if (!e.target.closest(".footer__back-to-top-btn")) return;

  e.preventDefault();
  e.stopPropagation();

  if (window.scrollTo) {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
});

